// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"10e395cb","673":"e99aa9e7"}[chunkId] + ".chunk.js";
};